import { render, staticRenderFns } from "./cloudManageBox.vue?vue&type=template&id=06eb3738&scoped=true&"
import script from "./cloudManageBox.vue?vue&type=script&lang=js&"
export * from "./cloudManageBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06eb3738",
  null
  
)

export default component.exports